<template>
  <div id="app">
    <div class="box" id="snowzone"></div>
    <div class="am-container am-margin-vertical-xl">
      <header id="header" class="am-margin-bottom-xl">
        <div id="header-title">
          <h2>{{title}}</h2>
        </div>
        <div id="header-content">
          <div id="header-content-left">
            <p>{{description}}</p>
          </div>
          <div id="header-content-right">
            <nav>
              <span class="am-margin-right-xs" v-for="nav in navList">
                <router-link :key="nav.id" :to="{path:`/${nav.slug}`}">{{nav.title}}</router-link>
              </span>
            </nav>
          </div>
        </div>
      </header>
      <router-view></router-view>
      <footer style="margin-top: 50px">
        <div>
          <span v-if="copyright" v-html="copyright" class="am-margin-right-xs"></span>
          <span v-if="loginUser">
            <router-link v-if="loginUser.id===1" :to="{path:'/edit'}" class="am-margin-right-xs">控制台</router-link>
            <router-link :to="{path:'/login'}" class="am-margin-right-xs">个人中心</router-link>
          </span>
          <span v-else>
            <router-link :to="{path:'/login'}" class="am-margin-right-xs">登录</router-link>
          </span>
        </div>
        <div v-if="icp" v-html="icp"></div>
        <audio v-show="false" id="mp3" :src="mp3Url" preload="none" loop></audio>
        <a v-if="!btnFlag&&mp3Url" @click="playMp3" style="position: fixed; top: 5px; right: 15px; text-align: center; width: 30px; height: 30px; line-height: 30px; border-radius: 10px; background-color: white; color: red">
          <i v-if="mp3Paused" class="am-icon-play"></i>
          <i v-else class="am-icon-pause"></i>
        </a>
        <a v-if="btnFlag" @click="backTop" style="position: fixed; bottom: 5px; right: 5px;">
          <img :src="`${fileUrl}/zero/option/top.png`" style="width: 50px"/>
        </a>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { apiCheckLogin, apiOptionGet, apiPageGetList } from '@/request'
export default {
  name: 'App',
  data () {
    return {
      title: '',
      description: '',
      copyright: '',
      icp: '',
      mp3Url: '',
      pageList: [],
      mp3Paused: true,
      btnFlag: false,
      scrollTop: 0
    }
  },
  computed: {
    ...mapGetters([ 'loginUser' ]),
    navList () {
      return this.pageList.length > 0 ? [{id:0,title:'首页',slug:''}].concat(this.pageList) : []
    }
  },
  mounted () {
    if(this.loginUser) {
      apiCheckLogin()
    }
    apiOptionGet().then(res => {
      this.title = res.title
      this.description = res.description
      this.copyright = res.copyright
      this.icp = res.icp
      this.fileUrl = res.fileUrl
      this.mp3Url = res.mp3Url
      this.$store.commit('option', res)
      document.getElementById("mp3").load()
      if(res.grayscale === 'true') {
        document.getElementsByTagName("html")[0].classList.add('grayscale');
      }
    })
    apiPageGetList().then(res => {
      this.pageList = res
    })
    // 返回顶部
    window.addEventListener('scroll', this.scrollToTop)
    // 满屏雪花
    var that = this
    setInterval(() => {
      var left = Math.random()*window.innerWidth;
      var height = Math.random()*window.innerHeight;
      var src = require("./assets/img/s"+Math.floor(Math.random()*2+1)+".png");//两张图片分别为"s1.png"、"s2.png"
      that.getSnow(left,height,src)
    },500);
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    playMp3 () {
      const mp3 = document.getElementById("mp3")
      if (mp3.paused === true) {
        mp3.play();
        this.mp3Paused = false
      } else {
        mp3.pause();
        this.mp3Paused = true
      }
    },
    backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    getSnow(left,height,src) {
      var div = document.createElement("div");
      var img = document.createElement("img");
      img.className = 'snow_img'
      div.appendChild(img);
      img.src = src;
      div.style.position = 'fixed'
      div.style.left= left+"px";
      div.style.height= height+"px";
      document.getElementById("snowzone").appendChild(div);
      setTimeout(function(){
        document.getElementById("snowzone").removeChild(div);
      },5000);
    }
  }
}
</script>

<style>
body {
  background-color: #f2f2f2;
}
.am-container {
  max-width: 720px;
}
.bq {
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  bottom: .5rem;
  display: inline-block!important;
}
.am-badge-bilibili {
  background-color: #fb7299;
}
.card {
  margin: 50px auto;
  padding: 15px;
  background: #fff;
  border-radius: 10px;
}
.am-article-bd pre {
  background-color: #23241f !important;
  color: #f8f8f2 !important;
  border: 0;
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding: 2px 0 0 29px;
}
.am-article-bd pre code {
  white-space: pre;
}
.am-article-bd .pre-numbering {
 	position: absolute;
 	top: 0;
 	left: 0;
 	width: 29px;
 	padding: 0 7px 0 0;
 	border-right: 1px solid #C3CCD0;
 	background: #282c34;
 	text-align: right;
}
.am-article-bd .copy-button {
  position: absolute;
  top: 0;
  right: 0;
  color: #282c34;
}
.mint-msgbox {
  max-width: 500px;
}
.mint-indicator-wrapper, .v-modal {
  background-color: #0000 !important;
}
.snow_img {
    animation: mymove 5s;
    height: 50px;
    position: absolute;
    opacity: 0;
}
@keyframes mymove {
    0%{bottom:100%;opacity:0;}
    50%{opacity:1;transform: rotate(1080deg);}
    100%{transform: rotate(0deg);opacity: 0;bottom:0;}
}
.postMenu::-webkit-scrollbar {
  display: none;
}
.postMenuShow {
  position: fixed;
  right: 0;
  bottom: 80px;
}
.postMenuHide {
  position: fixed;
  top: 15px;
  right: 15px;
}
.postMenu {
  height: 100%;
  width: 280px;
  background-color: white;
  border-left: solid 1px #f0f0f0;
  overflow-y: auto;
  padding: 10px;
}
.grayscale {
  -webkit-filter:grayscale(100%);
  filter:grayscale(100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue